export * from "@/ui/components/typography/TextBody/TextBody";
export * from "@/ui/components/typography/TextBody/TextBody.config";
